import { AxiosError } from 'axios'
import { useMutation, useQuery } from '@tanstack/react-query'
import { toMilliseconds } from '../Functions/toMilliseconds'
import useWbapiInstance from './useWbapiInstance'

export interface GcsFile {
  id: string
  name: string
  timeCreated: Date | undefined
  metadata: MetaData
  visitType: string | undefined
}

interface MetaData {
  source: string
  category: string
}

const bucket = 'wellbe-data-management.appspot.com'

export default function useMemberGcsFiles(aaneelId?: number) {
  const { api } = useWbapiInstance()

  const fileTypes = ['CCD', 'CCD-XML', 'ProgressNote']
  const query = useQuery<GcsFile[], AxiosError>({
    queryKey: ['memberGcsFiles', aaneelId],
    queryFn: async () => {
      const { data } = await api.get(`/api/v1/files/list`, {
        params: {
          bucket,
          path: `memberDocs/${aaneelId}/`,
          fileTypes,
        },
        paramsSerializer: {
          indexes: null,
        },
      })
      return data
    },
    staleTime: toMilliseconds({ hrs: 24 }),
    enabled: !!aaneelId,
  })

  const getSignedUrl = useMutation<string, AxiosError, string>({
    mutationFn: (name) =>
      api.get(`/api/v1/files/signed-url`, { params: { bucket, objectKey: `memberDocs/${aaneelId}/${name}` } }).then((resp) => resp.data),
  })

  return { ...query, getSignedUrl }
}
